export function getConsent() {
  if (typeof window !== 'undefined' && window?.Fides?.consent) {
    return window.Fides.consent
  }

  return {
    analytics: false,
    essential: false,
    functional: false,
    marketing: false
  }
}

export function getHasAnalyticsConsent() {
  const consent = getConsent()
  return consent.analytics
}

export function getHasFunctionalConsent() {
  const consent = getConsent()
  return consent.functional
}

export function getHasMarketingConsent() {
  const consent = getConsent()
  return consent.marketing
}
